<template>
	<div>
		<div class="d-flex flex-row align-items-center">
			<hundred-slider
				:color="color"
				:hideNumbers="true"
				:marks="[
					0,
					'Not at all like me',
					10,
					'Not much like me',
					30,
					'Somewhat unlike me',
					50,
					'Somewhat like me',
					70,
					'Much like me',
					90,
					'Very much like me',
					100,
					20,
					40,
					60,
					80,
				]"
				v-model="value.score"
			/>
		</div>
		<textarea
			class="form-control flex-grow mt-3 text-md"
			rows="5"
			placeholder="Explanation of rating..."
			v-model="value.reasoning"
		/>
	</div>
</template>

<script>
import HundredSlider from "@/components/HundredSlider";

export default {
	name: "ProfileQuestion",

	props: ["value", "color", "groupName"],

	components: { HundredSlider },

	data() {
		return {};
	},

	watch: {
		"value.score"() {
			if (this.value.score < 0) {
				this.value.score = 0;
			}
			if (this.value.score > 100) {
				this.value.score = 100;
			}
			this.$emit("input", this.value);
		},
		"value.reasoning"() {
			this.$emit("input", this.value);
		},
	},

	methods: {
		getDescriptor(score) {
			switch (score) {
				case 0:
					return "Not at all like me";
				case 1:
				case 2:
					return "Not much like me";
				case 3:
				case 4:
					return "Somewhat unlike me";
				case 5:
					return "Neutral";
				case 6:
				case 7:
					return "Somewhat like me";
				case 8:
				case 9:
					return "Much like me";
				case 10:
					return "Very much like me";
				default:
					return "";
			}
		},

		getColor() {
			switch (this.color) {
				case "yellow":
					return { "si-text-yellow": true };
				case "green":
					return { "si-text-green": true };
				case "blue":
					return { "si-text-blue": true };
				case "orange":
					return { "si-text-orange": true };
				default:
					return { "si-text-yellow": true };
			}
		},

		getHighlight(score) {
			if (this.result.score == score) {
				let ctx = this.getColor();
				ctx["score-highlight"] = true;
				return ctx;
			}

			return {};
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.number-input-containter {
	position: relative;
}
.number-input {
	width: 150px;
	height: 120px;
	font-size: 60px;
	text-align: center;
	padding-right: 0;
	padding-top: 0;
	padding-bottom: 0;
	padding-left: 16px;
}

.form-check-label {
	height: 24px;
	width: 20px;
}
tr {
	border-width: 2px !important;
	border-color: rgb(200, 200, 200) !important;
}
td,
th {
	position: relative;
	text-align: center;
	padding-top: 1rem;
	padding-bottom: 1rem;
	padding-left: 0.5rem;
	padding-right: 0.5rem;
	font-size: 18px;
	border-width: 2px !important;
	border-color: rgb(200, 200, 200) !important;
}
tr.pb-reduce td,
tr.pb-reduce th {
	padding-bottom: 0.25rem;
}
tr.pt-reduce td,
tr.pt-reduce th {
	padding-top: 0.25rem;
}
tr.pb-none td,
tr.pb-none th {
	padding-bottom: 0;
}
tr.pt-none td,
tr.pt-none th {
	padding-top: 0;
}
tr.number-line td {
	padding-left: 0;
	padding-right: 0;
}
.number-line-piece {
	width: 100;
	border-bottom: 3px solid rgb(200, 200, 200);
}
.number-line-mark {
	position: absolute;
	top: -7px;
	left: calc(50% - 8px);
	border-radius: 50%;
	width: 16px;
	height: 16px;
	background-color: rgb(200, 200, 200);
}

.number-line.si-text-yellow .number-line-mark {
	background-color: rgb(255, 205, 0) !important;
}
.number-line.si-text-orange .number-line-mark {
	background-color: rgb(254, 80, 0) !important;
}
.number-line.si-text-green .number-line-mark {
	background-color: rgb(51, 204, 51) !important;
}
.number-line.si-text-blue .number-line-mark {
	background-color: rgb(41, 204, 232) !important;
}

.number-line-end {
	position: absolute;
	right: -1px;
	top: -7px;
	height: 17px;
	width: 12px;
	border-left: 12px solid rgb(200, 200, 200);
	border-top: 8px solid transparent;
	border-bottom: 8px solid transparent;
}

.score-trans {
	transition: color 0.05s ease-in-out, transform 0.05s ease-in-out;
}

.score-highlight {
	transform: scale(1.5);
}

textarea {
	border-width: 2px !important;
	border-color: rgb(200, 200, 200) !important;
}

input[type="radio"] {
	width: 20px;
	height: 20px;
}
</style>
